import { AbstractIcon } from './abstract';
import { componentsRegistryService } from 'cruzo';

export class SandGlassIcon extends AbstractIcon {
  static selector = "sandglass-icon";

  getHTML() {
    return `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 64 64" style="enable-background:new 0 0 64 64;" xml:space="preserve">
        <path style="fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" d="
          M40.83,13.426c-6.177,1.423-23.641,0.615-23.641-2.56C17.189,6.385,45,6.63,45,11.413c0,8.539-1.661,15.802-13.511,20.362
          c-3.541,1.363-15.745,4.269-14.431,21.785c0,4.749,26.57,4.806,26.804,0.32c0.138-2.652-7.182-9.513-12.836-9.681
          c-4.473-0.133-9.982,3.821-9.982,6.8c0,2.225,23.957,3.748,23.957-2.34c0-11.512-7.872-14.679-13.905-16.775
          c-9.664-3.357-13.905-8.566-13.905-15.778"/>
        </svg>`
  }
}

componentsRegistryService.define(SandGlassIcon);
